module.exports = __webpack_public_path__ + "static/media/white-logo.9b73eb85.png";